const articleBodyItemProp = 'articleBody';
const tableOfContentsItemProp = 'tableOfContents';

const getArticleBody = () => {
  return document.querySelector(`[itemprop="${articleBodyItemProp}"]`);
};

const getHeadings = () => {
  const articleBody = getArticleBody();
  if (!articleBody) return null;

  return articleBody.querySelectorAll(['h2', 'h3']);
};

const existsTableOfContents = () => {
  return !!document.querySelector(`[itemprop="${tableOfContentsItemProp}"]`);
};

const generateAnchor = (id) => {
  const anchor = document.createElement('a');
  anchor.style.display = 'block';
  anchor.style.width = '100%';
  anchor.style.margin = 0;
  anchor.style.lineHeight = '21px';
  anchor.style.fontSize = '16px';
  anchor.style.fontWeight = '400';
  anchor.style.color = '#353026';
  anchor.style.fontFamily = '"Noto Sans JP", sans-serif';
  const content = document.createTextNode(`${id}`);
  anchor.appendChild(content);
  anchor.setAttribute('href', `#${id}`);
  return anchor;
};

const generateListItem = (id, index, isNest = false) => {
  const listItem = document.createElement('li');
  listItem.style.padding = '8px 0';
  listItem.style.margin = 0;
  listItem.style.listStyleType = 'none';
  if (isNest) {
    listItem.style.paddingLeft = '38px';
    const anchor = generateAnchor(`${id}`);
    listItem.appendChild(anchor);
    anchor.setAttribute('class', `list-item-h3`);
    return listItem;
  }
  if (isNest === false) {
    const anchor = generateAnchor(`${id}`);
    listItem.appendChild(anchor);
    anchor.setAttribute('class', `list-item-h2`);
    return listItem;
  }
};

const generateList = (headings) => {
  if (!headings) return;

  const list = document.createElement('ul');
  list.setAttribute('id', `menu-list`);
  list.style.padding = 0;
  list.style.margin = '16px 0 0';
  list.style.listStyle = 'none';
  Array.prototype.forEach.call(headings, (heading, index) => {
    const listItem = generateListItem(
      heading.id,
      index,
      heading.tagName === 'H3'
    );
    list.appendChild(listItem);
  });
  return list;
};

const generateTitle = () => {
  const title = document.createElement('p');
  title.style.fontSize = '26px';
  title.style.fontWeight = '400';
  title.style.margin = 0;
  title.style.textAlign = 'center';
  title.style.color = 'rgba(53, 48, 38, 1)';
  title.style.lineHeight = 1.5;
  title.style.letterSpacing = '0.04em';
  const content = document.createTextNode('Contents');
  title.appendChild(content);
  return title;
};

const generateHideButton = () => {
  const button = document.createElement('button');
  button.style.display = 'block';
  button.style.backgroundColor = 'rgba(243, 240, 236, 1)';
  button.style.color = 'rgba(53, 48, 38, 1)';
  button.style.border = 'none';
  button.style.padding = '9px 0';
  button.style.width = '87px';
  button.style.marginTop = '8px';
  button.style.marginLeft = 'auto';
  button.style.marginRight = 'auto';
  const content = document.createTextNode('hide');
  button.appendChild(content);
  button.setAttribute('id', `hideButton`);
  return button;
}

const generateTableOfContents = (headings) => {
  if (!headings) return;

  const tableOfContents = document.createElement('nav');
  tableOfContents.setAttribute('itemprop', tableOfContentsItemProp);
  tableOfContents.style.margin = '36px 0';
  tableOfContents.style.backgroundColor = '#ffffff';
  tableOfContents.style.border = '1px solid rgba(53, 48, 38, 0.1)';
  const title = generateTitle();
  tableOfContents.appendChild(title);
  const button = generateHideButton();
  tableOfContents.appendChild(button);
  const list = generateList(headings);
  tableOfContents.appendChild(list);
  return tableOfContents;
};

const addIdToHeading = () => {
  const headings = getHeadings();
  if (!headings) return;

  Array.prototype.forEach.call(headings, (heading) => {
    heading.id = heading.textContent;
  });
};

const addTableOfContents = () => {
  const articleBody = getArticleBody();
  const headings = getHeadings();
  if (!articleBody || !headings) return;

  const tableOfContents = generateTableOfContents(headings);
  const firstHeading = headings[0];
  if (!tableOfContents || !firstHeading) return;
  if (existsTableOfContents()) return;

  articleBody.insertBefore(tableOfContents, firstHeading);
};

addIdToHeading();
addTableOfContents();

// targetクリックイベント
const target = document.getElementById('hideButton');
const menuList = document.getElementById('menu-list');

target.addEventListener('click', function(){
  menuList.classList.toggle('hide');

  if (target.textContent === 'hide') {
    target.textContent = 'show';
  }
  else {
  target.textContent = 'hide';
  }
});